import { render, staticRenderFns } from "./ConfiguratorItemsListCard.vue?vue&type=template&id=d051ad22&"
import script from "./ConfiguratorItemsListCard.vue?vue&type=script&lang=ts&"
export * from "./ConfiguratorItemsListCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports